import { createAsyncThunk } from '@reduxjs/toolkit';
import {
    callApproveExpenseVoucher,
    callCreateExpenseCategory,
    callCreateExpenseVoucher,
    callDeleteExpenseCategory,
    callDeleteExpenseVoucher,
    callGetExpenseCategories,
    callGetExpenseVouchers,
    callUpdateExpenseCategory,
} from 'helpers/api_helper';

const toTotal = (response: any) => Number(response?.headers?.['x-total-count'] || 0);

export interface IExpenseCategoryPayload {
  name: string;
  description?: string;
  active?: boolean;
}

export interface IExpenseVoucherPayload {
  categoryId: number;
  amount: number;
  reason: string;
  expenseDate?: string;
}

export const getExpenseCategories = createAsyncThunk(
  'expenses/getExpenseCategories',
  async (param: any, { rejectWithValue }) => {
    try {
      const response: any = await callGetExpenseCategories(param);
      return {
        data: response?.data,
        total: toTotal(response),
      };
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  },
);

export const createExpenseCategory = createAsyncThunk(
  'expenses/createExpenseCategory',
  async (param: IExpenseCategoryPayload, { rejectWithValue }) => {
    try {
      return await callCreateExpenseCategory(param);
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  },
);

export const updateExpenseCategory = createAsyncThunk(
  'expenses/updateExpenseCategory',
  async ({ id, param }: { id: number; param: IExpenseCategoryPayload }, { rejectWithValue }) => {
    try {
      return await callUpdateExpenseCategory(id, param);
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  },
);

export const deleteExpenseCategory = createAsyncThunk(
  'expenses/deleteExpenseCategory',
  async (id: number, { rejectWithValue }) => {
    try {
      await callDeleteExpenseCategory(id);
      return id;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  },
);

export const getExpenseVouchers = createAsyncThunk(
  'expenses/getExpenseVouchers',
  async (param: any, { rejectWithValue }) => {
    try {
      const response: any = await callGetExpenseVouchers(param);
      return {
        data: Array.isArray(response?.data) ? response.data : [],
        total: toTotal(response),
      };
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  },
);

export const createExpenseVoucher = createAsyncThunk(
  'expenses/createExpenseVoucher',
  async (param: IExpenseVoucherPayload, { rejectWithValue }) => {
    try {
      return await callCreateExpenseVoucher(param);
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  },
);

export const deleteExpenseVoucher = createAsyncThunk(
  'expenses/deleteExpenseVoucher',
  async (id: number, { rejectWithValue }) => {
    try {
      await callDeleteExpenseVoucher(id);
      return id;
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  },
);

export const approveExpenseVoucher = createAsyncThunk(
  'expenses/approveExpenseVoucher',
  async (
    { id, approved = true, note = '' }: { id: number; approved?: boolean; note?: string },
    { rejectWithValue },
  ) => {
    try {
      return await callApproveExpenseVoucher(id, { approved, note });
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  },
);
